export default (body) => {
  const byteCharacters = atob(body)
  const byteArrays = []
  const sliceSize = 512
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }
  return byteArrays
}



// WEBPACK FOOTER //
// ./src/binary-file-converter.js